export default __webpack_public_path__ + "static/bioxag-f79e1cf2b02fd279a3a9d4737f3b93cf.png";